<template>
  <div class="statistic">
    <div class="statistic-menu">
      <div class="history-menu_datepicker">
        <span class="history-menu_datepicker-toogle" v-on:click="openPicker()"></span>
        <div class="datepicker-cnt"
             v-show="datepicker.show">
          <div class="text-center"
               v-bind:class="{ 'error-shake' : datepicker.error.range }">
            Выберите диапазон
          </div>
          <datepicker
              ref="datepicker"
              :language="datepicker.lang.ru"
              :input-class="datepicker.inputClass"
              :disabledDates="datepicker.disabledDates"
              :highlighted="datepicker.highlighted"
              :monday-first="true"
              :inline="true"
              v-model="datepicker.value">
          </datepicker>
          <div class="datepicker-btn">
            <button class="btn btn-cancel" v-on:click="cancelPicker()">отменить</button>
            <button class="btn btn-success" v-on:click="acceptPicker()">подтвердить</button>
          </div>
        </div>
      </div>
      <div class="text-italic" v-if="datepicker.highlighted.to">
        c {{ datepicker.highlighted.from | moment("DD.MM.YYYY") }},
        по {{ datepicker.highlighted.to | moment("DD.MM.YYYY") }}
      </div>
    </div>
    <div>
      <div class="total-mileage" v-if="showFields.muchDrive">
        <div class="total-mileage_name">
          Вы проехали
        </div>
        <div class="text-center">
          <span class="total-mileage_value">{{statistic.km_int}}</span>км
        </div>
      </div>
      <!-- Провели в пути/В Пробках -->
      <div class="statistic-row statistic-row__green" v-if="showFields.inRoute">
        <div class="statistic-row_cnt">
          <div class="statistic-row_left">
            <div class="statistic-row_name">
              Всего провели в пути
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt"
                   v-for="(item, idx) in rt_int_Calc"
                   v-bind:key="idx">
                <span class="statistic-row_val-number">{{item.val}}</span>
                <span class="statistic-row_val-name">{{item.name}}</span>
              </div>
            </div>
          </div>
          <div class="statistic-row_right">
            <div class="statistic-row_name">
              из этого в пробках
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt"
                   v-for="(item, idx) in jm_int_Calc"
                   v-bind:key="idx">
                <span class="statistic-row_val-number">{{item.val}}</span>
                <span class="statistic-row_val-name">{{item.name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="statistic_ratio">
          <div class="statistic_ratio-left">
          </div>
          <div class="statistic_ratio-right" v-bind:style="{ 'width' : ratioInroute + '%' }">
            {{ ratioInroute }}%
          </div>
        </div>
      </div>
      <!-- Работа двигателя / в автозапуске -->
      <div class="statistic-row statistic-row__blue" v-if="showFields.engine">
        <div class="statistic-row_cnt">
          <div class="statistic-row_left">
            <div class="statistic-row_name">
              Работа двигателя
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt"
                   v-for="(item, idx) in en_int_Сalc"
                   v-bind:key="idx">
                <span class="statistic-row_val-number">{{item.val}}</span>
                <span class="statistic-row_val-name">{{item.name}}</span>
              </div>
            </div>
          </div>
          <div class="statistic-row_right">
            <div class="statistic-row_name">
              в автозапуске
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt"
                   v-for="(item, idx) in rs_int_Сalc"
                   v-bind:key="idx">
                <span class="statistic-row_val-number">{{item.val}}</span>
                <span class="statistic-row_val-name">{{item.name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="statistic_ratio">
          <div class="statistic_ratio-left">
          </div>
          <div class="statistic_ratio-right" v-bind:style="{ 'width' : ratioEngine + '%' }">
            {{ratioEngine}}%
          </div>
        </div>
      </div>
      <!-- Горючего потрачено / в автозапуске -->
      <div class="statistic-row statistic-row__purple" v-if="showFields.fuel">
        <div class="statistic-row_cnt">
          <div class="statistic-row_left">
            <div class="statistic-row_name">
              Горючего потрачено
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt">
                <span class="statistic-row_val-number">{{statistic.en_fuel}}</span>
                <span class="statistic-row_val-name">л</span>
              </div>
            </div>
          </div>
          <div class="statistic-row_right">
            <div class="statistic-row_name">
              в автозапуске
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt">
                <span class="statistic-row_val-number">{{statistic.rs_fuel}}</span>
                <span class="statistic-row_val-name">л</span>
              </div>
            </div>
          </div>
        </div>
        <div class="statistic_ratio">
          <div class="statistic_ratio-left">
          </div>
          <div class="statistic_ratio-right" v-bind:style="{ 'width' : ratioFuel + '%' }">
            {{ratioFuel}}%
          </div>
        </div>
      </div>
      <!-- Вы потратили рублей / в автозапуске -->
      <p class="statistic-description" v-if="showFields.fuelPrice">
        При средней стоимости бензина {{statistic.fuel_prices_mean}} рубля
        за выбранный период
      </p>
      <div class="statistic-row statistic-row__pink" v-if="showFields.moneyRoute">
        <div class="statistic-row_cnt">
          <div class="statistic-row_left">
            <div class="statistic-row_name">
              Вы потратили
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt">
                <span class="statistic-row_val-number">{{priceFuelAll}}</span>
                <span class="statistic-row_val-name">руб</span>
              </div>
            </div>
          </div>
          <div class="statistic-row_right">
            <div class="statistic-row_name">
              в автозапуске
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt">
                <span class="statistic-row_val-number">{{priceFuelAS}}</span>
                <span class="statistic-row_val-name">руб</span>
              </div>
            </div>
          </div>
        </div>
        <div class="statistic_ratio">
          <div class="statistic_ratio-left">
          </div>
          <div class="statistic_ratio-right" v-bind:style="{ 'width' : ratioFuel + '%' }">
            {{ratioFuel}}%
          </div>
        </div>
      </div>
      <!-- Всего списано денег -->
      <div class="money-spent" v-if="showFields.moneySim">
        <div class="money-spent_title">
          С номера SIM карты устройства списано
        </div>
        <div class="text-center">
          <span class="money-spent_value">{{statistic.money_spent_sim}}<span class="money-spent_units">руб</span></span>
        </div>
      </div>
      <!-- В среднем -->
      <div class="statistic-row" v-if="showFields.moneyAw">
        <div class="statistic-row_cnt">
          <div class="statistic-row_left">
            <div class="statistic-row_name">
              В среднем за день
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt">
                <span class="statistic-row_val-number">{{averagePerDay}}</span>
                <span class="statistic-row_val-name">руб</span>
              </div>
            </div>
          </div>
          <div class="statistic-row_right">
            <div class="statistic-row_name">
              За 100 км
            </div>
            <div class="statistic-row_val">
              <div class="statistic-row_val-cnt">
                <span class="statistic-row_val-number">{{pricePer100}}</span>
                <span class="statistic-row_val-name">руб</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-title statistic_empty">
        Сведения отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../../main'
  import Datepicker from 'vuejs-datepicker';
  import {en, ru} from 'vuejs-datepicker/dist/locale'

  export default {
    data : function () {
      return{
        datepicker : {
          show : false,
          value: '',
          lang : {
            ru : ru,
            en : en
          },
          parity : 0,
          highlighted: {
            from: this.$moment().subtract(2, 'day')._d,
            to: this.$moment().subtract(1, 'day')._d
          },
          disabledDates: {
            from: this.$moment().subtract(1, 'day')._d
          },
          error : {
            range : false
          },
          inputClass : 'datepickerField'
        },
        statistic : {
          rt_int  	       : 0, // Время в пути
          jm_int	         : 0, // Время в пробках
          rs_int	         : 0, // Автозапуск
          en_int	         : 0, // Работающий двигатель
          km_int	         : 0, // Пройдено километров
          rs_fuel	         : 0, // Топливо в автозапуске
          en_fuel	         : 0, // Топливо всего
          money_spent_sim  : 0, // Денег потрачено
          fuel_prices_mean : 0,	// Средняя стоимость бензина
        },
        showFields : {
          muchDrive  : false,
          inRoute    : false,
          engine     : false,
          fuel       : false,
          fuelPrice  : false,
          moneyRoute : false,
          moneySim   : false,
          moneyAw    : false
        }
      }
    },
    mounted : function () {
      this.getStatistic();
    },
    methods : {
      // Запрос данных
      getStatistic : function () {
        let ddF = this.$moment(this.datepicker.highlighted.from).set({ hour:0,minute:0,second:0,millisecond:0 }).utcOffset(0).format('YYYY-MM-DDTHH:mm:ss'),
            ddT = this.$moment(this.datepicker.highlighted.to  ).subtract(-1, 'day').set({ hour:0,minute:0,second:0,millisecond:0 }).utcOffset(0).format('YYYY-MM-DDTHH:mm:ss');

        let src = 'cars/' + this.activeCar.id + '/stats/total/?dt_start=' + ddF + '&dt_stop=' + ddT;

        HTTP.get( src )
          .then( response => {
            this.statistic = response.data;
            this.checkShowFields();
          }).catch( error => {
            this.$store.dispatch('errorResponse', error );
          })
        ;
      },
      // Открываем календарь
      openPicker : function () {
        this.datepicker.show === true ? this.datepicker.show = false : this.datepicker.show = true
      },
      // Закрываем календарь
      cancelPicker : function () {
        this.datepicker.show = false;
      },
      // Выбрали диапазон
      acceptPicker : function () {
        let _this = this;
        if( this.datepicker.highlighted.from === '' || this.datepicker.highlighted.to === '' ){
          this.datepicker.error.range = true;
          setTimeout(function () { _this.datepicker.error.range = false; }, 2000);
        }else{
          this.datepicker.show = false;
          this.getStatistic();
        }
      },
      // Проверяем что показываем
      checkShowFields : function () {
        this.showFields = {
          muchDrive  : true,
          inRoute    : true,
          engine     : true,
          fuel       : true,
          fuelPrice  : true,
          moneyRoute : true,
          moneySim   : true,
          moneyAw    : true
        };

        if( !this.statistic.km_int ){
          this.showFields.muchDrive = false;
        }
        if( !this.statistic.rt_int ){
          this.showFields.inRoute = false;
        }
        if( !this.statistic.en_int ){
          this.showFields.engine = false;
        }
        if( !this.statistic.en_fuel ){
          this.showFields.fuel = false;
        }
        if( !this.statistic.en_fuel || !this.statistic.fuel_prices_mean ){
          this.showFields.fuelPrice = false;
          this.showFields.moneyRoute = false;
        }
        if( !this.statistic.money_spent_sim ){
          this.showFields.moneySim = false;
        }
        if( !this.statistic.money_spent_sim ){
          this.showFields.moneyAw = false
        }
      },
      // пересчитываем минуты
      calcTimeValue : function ( minutes ) {
        let res = [];

        if( minutes > 60 ){
          if( minutes / 60 > 24 ){ // дни
            let dd = Math.floor( minutes / 60 / 24 );
            res.push({  name : 'дн', val : dd });
            if( minutes - (60*24*dd) > 59 ){
              res.push({  name : 'ч', val : Math.floor( (minutes - (60*24*dd) )/60 ) });
            }else{
              res.push({  name : 'мин', val : Math.floor( minutes - (60*24*dd) ) });
            }
          }else{ // часы
            let hh = Math.floor( (minutes / 60) );
            res.push({  name : 'ч', val : hh });
            res.push({  name : 'мин', val : Math.floor(minutes - hh * 60) });
          }
        }else{ // минуты
          res.push({ name : 'мин',  val : minutes });
        }

        return res;
      }
    },
    computed: {
      activeCar : function () {
        return this.$store.state.cars.current
      },
      timeZone : function () {
        return this.$store.state.timezone
      },
      ratioInroute : function () {
        let a = Math.round( this.statistic.jm_int / this.statistic.rt_int * 100 );
        if(!isFinite(a) || isNaN(a)){ return 0 }else{ return a }
      },
      ratioEngine : function () {
        let a = Math.round( this.statistic.rs_int / this.statistic.en_int * 100 );
        if(!isFinite(a) || isNaN(a)){ return 0 }else{ return a }
      },
      ratioFuel : function () {
        let a = Math.round( this.statistic.rs_fuel / this.statistic.en_fuel * 100 );
        if(!isFinite(a) || isNaN(a)){ return 0 }else{ return a }
      },
      priceFuelAll : function () {
        let a = (this.statistic.en_fuel * this.statistic.fuel_prices_mean).toFixed(1);
        if(!isFinite(a) || isNaN(a)){ return 0 }else{ return a }
      },
      priceFuelAS : function () {
        let a = (this.statistic.rs_fuel * this.statistic.fuel_prices_mean).toFixed(1);
        if(!isFinite(a) || isNaN(a)){ return 0 }else{ return a }
      },
      pricePer100 : function () {
        let a =  (this.statistic.money_spent_sim / this.statistic.km_int * 100).toFixed(1)
        if(!isFinite(a) || isNaN(a)){ return 0 }else{ return a }
      },
      averagePerDay : function () {
        let a = this.$moment( this.datepicker.highlighted.from );
        let b = this.$moment( this.datepicker.highlighted.to );
        return (this.statistic.money_spent_sim / (b.diff(a, 'days')+1)).toFixed(1)
      },

      rt_int_Calc : function () {
        return this.calcTimeValue(this.statistic.rt_int);
      },
      jm_int_Calc : function () {
        return this.calcTimeValue(this.statistic.jm_int);
      },
      en_int_Сalc : function () {
        return this.calcTimeValue(this.statistic.en_int);
      },
      rs_int_Сalc : function () {
        return this.calcTimeValue(this.statistic.rs_int);
      },
    },
    watch : {
      'datepicker.value' : function (newVal, oldVal) {
        if( oldVal === '' ){
          this.datepicker.highlighted.from = newVal;
          this.datepicker.parity = 1;
        }else{
          if( this.datepicker.parity === 1 ){
            if( this.datepicker.highlighted.from < newVal  ){
              this.datepicker.highlighted.to = newVal;
            }else{
              this.datepicker.highlighted.to = this.datepicker.highlighted.from;
              this.datepicker.highlighted.from = newVal;
            }
            this.datepicker.parity = 0;
          }else{
            this.datepicker.highlighted.from = newVal;
            this.datepicker.highlighted.to = '';
            this.datepicker.parity = 1;
          }
        }
      }
    },
    components : {
      Datepicker
    }
  }
</script>